const state = {
  token: null,
};

const mutations = {
  SET_POLLING_TOKEN: (state, token) => {
    state.token = token;
  },
};

const actions = {
  setPollingToken: ({ commit }, token) => {
    commit("SET_POLLING_TOKEN", token);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
